module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/header-groups/header-groups.component.css
// module id = ./src/app/examples/header-groups/header-groups.component.css
// module chunks = main